
import { computed, defineComponent, onBeforeUnmount, Ref, ref } from "vue";
import { ElConfigProvider } from "element-plus";
import useEmitter from "@/composables/Emmiter";
import Button from "@/components/Button.vue"


export default defineComponent({
  name: "ModalAdicionarLubrificante",
  components: {
    Button, 
    ElConfigProvider
  },
  props: {
    fechaModal: Function,
  },
  setup(props, { emit }) {
    //ALERTS TOASTS
    const spanWarning = ref(false);

    //VARIAVEIS DE CONTROLE
    const loadSalvar: Ref<boolean> = ref(false);
    const emitter = useEmitter();
    const imagem = ref<HTMLInputElement>();
    const marcaForm: any = ref({
        nome: "",
        tipoProduto: "",
        imagem: "",
    });
    
    function verifySelectValues(e) {
      e.preventDefault();
      if (!marcaForm.value.tipoProduto || !marcaForm.value.nome) {
        spanWarning.value = true;
        return true;
      }
      spanWarning.value = false;
      addMarca();
    }

    async function addMarca() {
      await emitter.emit("addMarca", {
        marcaForm: marcaForm.value,
      });
      // resetar outros campos do form (se necessário)
        marcaForm.value = {
          nome: "",
          tipoProduto: "",
          imagem: "",
        };
    }

    // helper para gerar preview
    let currentObjectUrl: string | null = null;
    function buildImagePreview(img: any) {
      if (!img) return null;
      if (img instanceof File) {
        if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = URL.createObjectURL(img);
        return currentObjectUrl;
      }
      // string (URL)
      return typeof img === "string" ? img : null;
    }

    const fileName = computed(() => {
        const v = marcaForm.value.imagem;
        return v instanceof File ? v.name : "";
    });

    function handleImgFileChange(event: Event) {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (file) {
        marcaForm.value.imagem = file;
        marcaForm.value.imagemPreview = buildImagePreview(file);
      }
    }

    // handlers para atualizar o spinner e fechar o modal quando finalizado
    const startHandler = () => {
      loadSalvar.value = true;
    };

    const finishHandler = (payload?: any) => {
      loadSalvar.value = false;
      // fecha o modal somente depois de terminar
      // opcional: você pode checar payload.success para mostrar mensagem
      if(payload?.success){
        props.fechaModal && props.fechaModal();
      }
    };

    if (emitter && emitter.on) {
      emitter.on("addMarca:start", startHandler);
      emitter.on("addMarca:finish", finishHandler);
    }

    // remove listeners quando componente desmontar
    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("addMarca:start", startHandler);
        emitter.off("addMarca:finish", finishHandler);
      }
    });

    function openFileDialog() {
      imagem.value?.click();
    }
    

    return {
      spanWarning,
      marcaForm,
      verifySelectValues,
      loadSalvar,
      handleImgFileChange,
      fileName,
      openFileDialog,
      imagem
    };
  }
});
